/**
 * @readonly
 * @enum {number}
 */
export const EJustifyPages = {
  ALL_0: 0,
  PREV_1: 1,
  NEXT_2: 2,
};

const setPageItem = (index, array) => {
  const page = {
    index: index,
    content: index + 1,
    selected: index === this.selected - 1,
  };
  array.push(page);
};

const setBreakView = (justifyPages, array) => {
  const breakView = {
    disabled: false,
    breakView: true,
    justifyPages,
  };
  array.push(breakView);
};

export class PaginateHelper {
  /** @param {{pagesBefore: number, pagesAfter: number, justifyPages: EJustifyPages, pageCount: number, selected: number}}  */
  constructor({
    pagesBefore, pagesAfter, justifyPages, pageCount, selected,
  }) {
    /** @readonly @type {number} */
    this.pagesBefore = pagesBefore;

    /** @readonly @type {number} */
    this.pagesAfter = pagesAfter;

    /** @readonly @type {EJustifyPages} */
    this.justifyPages = justifyPages;

    /** @readonly @type {number} */
    this.pageCount = pageCount;

    /** @readonly @type {number} */
    this.selected = selected;

    this.items = [];
  }

  _setPageItem(index, array = this.items) {
    const page = {
      index: index,
      content: index + 1,
      selected: index === this.selected - 1,
    };
    array.push(page);
  }

  _setBreakView(justifyPages, array = this.items) {
    const breakView = {
      disabled: false,
      breakView: true,
      justifyPages,
    };
    array.push(breakView);
  }

  getPagesArray() {
    let beforeCount;
    let afterCount;

    if (this.justifyPages === EJustifyPages.NEXT_2) {
      beforeCount = this.pagesBefore + this.pagesAfter;
      afterCount = 0;
    } else if (this.justifyPages === EJustifyPages.PREV_1) {
      beforeCount = 0;
      afterCount = this.pagesBefore + this.pagesAfter;
    } else {
      beforeCount = this.pagesBefore;
      afterCount = this.pagesAfter;
    }

    // 5 = 2 margins + 2 breaks + 1 current page
    if (this.pageCount <= 5 + beforeCount + afterCount) {
      for (let index = 0; index < this.pageCount; index++) {
        this._setPageItem(index);
      }
    } else {
      const pageIndex = this.selected - 1;

      const cutBefore = Math.max(0, beforeCount - pageIndex);
      const cutAfter = Math.max(0, afterCount + pageIndex - this.pageCount + 1);

      const from = Math.max(0, pageIndex - beforeCount - cutAfter);
      const to = Math.min(this.pageCount, pageIndex + afterCount + 1 + cutBefore);

      // :
      // [1] :
      // [1] [2] :
      // [1] [...] :
      const start = [];
      if (from === 1) {
        this._setPageItem(0, start);
      } else if (from === 2) {
        this._setPageItem(0, start);
        this._setPageItem(1, start);
      } else if (from >= 3) {
        this._setPageItem(0, start);
        setBreakView(EJustifyPages.NEXT_2, start);
      }
      const addToEnd = 2 - start.length;

      // :
      // : [-1]
      // : [-2] [-1]
      // : [...] [-1]
      const end = [];
      if (to === this.pageCount - 1) {
        this._setPageItem(this.pageCount - 1, end);
      } else if (to === this.pageCount - 2) {
        this._setPageItem(this.pageCount - 2, end);
        this._setPageItem(this.pageCount - 1, end);
      } else if (to <= this.pageCount - 3) {
        this._setBreakView(EJustifyPages.PREV_1, end);
        this._setPageItem(this.pageCount - 1, end);
      }
      const addToStart = 2 - end.length;

      this.items.push(...start);

      for (let index = Math.max(from - addToStart, 0); index < pageIndex; index++) {
        this._setPageItem(index);
      }

      this._setPageItem(pageIndex);

      for (let index = pageIndex + 1; index < Math.min(to + addToEnd, this.pageCount); index++) {
        this._setPageItem(index);
      }

      this.items.push(...end);
    }

    return this.items;
  }
}
